import { Component } from '@angular/core';
import {Subscription} from "rxjs";
import {GameService} from "../../../../services/game.service";
import {Router} from "@angular/router";
import {Game} from "../../../../models/game.class";
import {ProviderModel} from "../../../../models/provider.model";
import {TrackingHelperService} from "../../../../services/tracking-helper.service";

@Component({
  selector: 'app-recommended',
  templateUrl: './recommended.component.html',
  styleUrls: ['./recommended.component.scss']
})
export class RecommendedComponent {

  recommendedGames: Game[] = [];
  recommendedSubs?: Subscription;

  favouritesSubs?: Subscription;
  favouriteIds: number[] = [];

  // providers: ProviderModel[] = [];
  // providerSubs: Subscription;

  randomGamesForCarousel: Game[] = [];
  gameSubs?: Subscription;

  userHasTracker: boolean;


  constructor(
    private gameService: GameService,
    private trackingService: TrackingHelperService,
    private router: Router
  ) {
    this.userHasTracker = !!this.trackingService.getTracker();

    this.recommendedSubs = this.gameService.getRecommendedGames().subscribe(games => {
        this.recommendedGames = games;
    })

    //set carousels
    // this.providerSubs = this.gameService.providers$.subscribe(p => {
    //   this.providers = p.filter(p => p.gameList && p.gameList.length)
    //   if (!this.providers.length) {
    //     this.providers = this.gameService.providers;
    //   }
    // })

    this.gameSubs = this.gameService.getGames().subscribe(games => {
      this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);
    })

  }

  ngOnInit(){
    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })
  }

  launchGame(id:number): void {
    let chosenGame = this.recommendedGames?.find(g=>g.id === id);
    if (chosenGame && chosenGame.enabled !== false){
      // chosenGame.enabled is "undefined" for Rival brands and "true" for enabled games in gamingpodium brands
      if(chosenGame.launchUrl){
        this.router.navigate(['play', chosenGame.slug])
      } else {
        this.router.navigate(['details', chosenGame.slug])
      }
    }
  }


  ngOnDestroy(){
    this.recommendedSubs?.unsubscribe();
    this.favouritesSubs?.unsubscribe();
    this.gameSubs?.unsubscribe();
    // this.providerSubs?.unsubscribe();
  }



}
